import { NavLink } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faHome, faUser, faBell, faBookmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
function Footer() {
  library.add(faHome, faUser, faBell, faBookmark);
    return (
      <footer>
        <NavLink className={({ isActive }) => (isActive ? 'active' : null)} to='/'><FontAwesomeIcon icon="home" /></NavLink>
        <NavLink to='/Profile'><FontAwesomeIcon icon="user" /></NavLink>
        <NavLink to='/Notice'><FontAwesomeIcon icon="bell" /></NavLink>
        <NavLink to='/Bookmark'><FontAwesomeIcon icon="bookmark" /></NavLink>
      </footer>
    );
  }
  
  export default Footer;
  